import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { SSO_CONFIG } from '@elementary/common-ui/constants/queryKeys';
import * as api from '../api';
import { CreateSsoRequest, EnableSsoRequest, UpdateSsoRequest } from '../types';

export const useSso = () => {
  const queryClient = useQueryClient();
  const dataQuery = useQuery({
    queryKey: [SSO_CONFIG],
    queryFn: api.fetchSsoConfig,
  });

  const invalidateSsoConfig = () => {
    queryClient.invalidateQueries([SSO_CONFIG]);
  };

  const enableMutation = useMutation({
    mutationFn: (data: EnableSsoRequest) => api.enableSsoConfig(data),
    onSuccess: invalidateSsoConfig,
  });

  const createMutation = useMutation({
    mutationFn: (data: CreateSsoRequest) => api.createSsoConfig(data),
    onSuccess: invalidateSsoConfig,
  });

  const updateMutation = useMutation({
    mutationFn: (data: UpdateSsoRequest) => api.updateSsoConfig(data),
    onSuccess: invalidateSsoConfig,
  });

  const deleteMutation = useMutation({
    mutationFn: () => api.clearSsoConfig(),
    onSuccess: invalidateSsoConfig,
  });

  return {
    data: dataQuery.data,
    isLoading:
      dataQuery.isLoading ||
      enableMutation.isLoading ||
      createMutation.isLoading ||
      updateMutation.isLoading ||
      deleteMutation.isLoading,
    error: dataQuery.error,
    enable: enableMutation.mutateAsync,
    create: createMutation.mutateAsync,
    update: updateMutation.mutateAsync,
    delete: deleteMutation.mutateAsync,
  };
};
